'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.LiterallycanvasPainter = /*#__PURE__*/function () {
  function LiterallycanvasPainter(view) {
    (0, _classCallCheck2["default"])(this, LiterallycanvasPainter);
    this.view = view;
    this.baseUrl = Entry.painterBaseUrl;
    this.file = {
      id: Entry.generateHash(),
      name: '새그림',
      modified: false,
      mode: 'new' // new or edit
    };
    this._keyboardEvents = [];
    Entry.addEventListener('pictureImport', this.addPicture.bind(this));
    Entry.addEventListener('run', this.detachKeyboardEvents.bind(this));
    Entry.addEventListener('stop', this.attachKeyboardEvents.bind(this));

    //dropdown header dispose
    $('body').on('mouseup', '.active li', function () {
      $('.painterTopHeader.active').removeClass('active');
    });
    this.clipboard = null;
  }
  return (0, _createClass2["default"])(LiterallycanvasPainter, [{
    key: "initialize",
    value: function initialize() {
      if (this.lc) {
        return;
      }
      var that = this;
      var imgURL = that.baseUrl;
      var bgImage = new Image();
      bgImage.src = "".concat(imgURL, "/transparent-pattern.png");
      var WIDTH = 960;
      var HEIGHT = 540;
      that.lc = LC.init(that.view, {
        imageURLPrefix: imgURL,
        zoomMax: 3.0,
        zoomMin: 0.5,
        toolbarPosition: 'bottom',
        imageSize: {
          width: WIDTH,
          height: HEIGHT
        },
        backgroundShapes: [LC.createShape('Rectangle', {
          x: 0,
          y: 0,
          width: WIDTH,
          height: HEIGHT,
          strokeWidth: 0,
          strokeColor: 'transparent'
        })]
      });
      //that.lc.respondToSizeChange();

      bgImage.onload = function () {
        that.lc.repaintLayer('background');
      };
      var watchFunc = function watchFunc(e) {
        if (e && (e.shape && !e.opts && e.shape.isPass || e.opts && e.opts.isPass)) {
          Entry["do"]('processPicture', e, that.lc);
        } else {
          Entry["do"]('editPicture', e, that.lc);
        }
        if (Entry.stage.selectedObject) {
          that.file.modified = true;
        }
      };
      that.lc.on('clear', watchFunc);
      that.lc.on('remove', watchFunc);
      that.lc.on('shapeEdit', watchFunc);
      that.lc.on('shapeSave', watchFunc);
      that.lc.on('toolChange', that.updateEditMenu.bind(that));
      that.lc.on('lc-pointerdrag', that.stagemousemove.bind(that));
      that.lc.on('lc-pointermove', that.stagemousemove.bind(that));
      that.initTopBar();
      that.updateEditMenu();
      that.attachKeyboardEvents();
    }
  }, {
    key: "show",
    value: function show() {
      if (!this.lc) {
        this.initialize();
      }
      this.isShow = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isShow = false;
    }
  }, {
    key: "changePicture",
    value: function changePicture() {
      var _this = this;
      var picture = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.file && this.file.id === picture.id) {
        if (!this.file.isUpdate) {
          Entry.stage.updateObject();
          this.file.isUpdate = true;
        }
        return;
      } else if (!this.file.modified) {
        this.afterModified(picture);
      } else {
        if (this.isConfirm) {
          return;
        }
        this.isConfirm = true;
        var wasRun = false;
        if (Entry.engine.state === 'run') {
          Entry.engine.toggleStop();
          wasRun = true;
        }
        Entry.modal.confirm(Lang.Menus.save_modified_shape).then(function (result) {
          _this.isConfirm = false;
          if (result === true) {
            _this.fileSave(true);
          } else {
            _this.file.modified = false;
          }
          if (!wasRun) {
            _this.afterModified(picture);
          } else {
            Entry.playground.injectPicture();
          }
        });
      }
      Entry.stage.updateObject();
      this.file.isUpdate = true;
    }
  }, {
    key: "afterModified",
    value: function afterModified(picture) {
      var file = this.file;
      file.modified = false;
      this.lc.clear(false);
      if (picture.id) {
        file.id = picture.id || Entry.generateHash();
        file.name = picture.name;
        file.mode = 'edit';
        file.objectId = picture.objectId;
        this.addPicture(picture, true);
      } else {
        file.id = Entry.generateHash();
      }
      // INFO: picture 변경시마다 undoStack 리셋
      this.lc.undoStack = [];
      Entry.stateManager.removeAllPictureCommand();
    }
  }, {
    key: "getImageSrc",
    value: function getImageSrc(picture) {
      var _ref = picture || {},
        fileurl = _ref.fileurl;
      if (fileurl) {
        return fileurl;
      }
      var _ref2 = picture || {},
        _ref2$imageType = _ref2.imageType,
        imageType = _ref2$imageType === void 0 ? 'png' : _ref2$imageType,
        filename = _ref2.filename;
      return "".concat(Entry.defaultPath, "/uploads/").concat(filename.substring(0, 2), "/").concat(filename.substring(2, 4), "/image/").concat(filename, ".").concat(imageType);
    }
  }, {
    key: "addPicture",
    value: function addPicture(picture, isOriginal) {
      var image = new Image();
      if (picture.fileurl) {
        image.src = picture.fileurl;
      } else {
        // deprecated
        image.src = "".concat(Entry.defaultPath, "/uploads/").concat(picture.filename.substring(0, 2), "/").concat(picture.filename.substring(2, 4), "/image/").concat(picture.filename, ".png");
      }
      var dimension = picture.dimension;
      var shape = LC.createShape('Image', {
        x: 480,
        y: 270,
        width: dimension.width,
        height: dimension.height,
        image: image
      });
      this.lc.saveShape(shape, !isOriginal);
      image.onload = function () {
        this.lc.setTool(this.lc.tools.SelectShape);
        this.lc.tool.setShape(this.lc, shape);
      }.bind(this);
    }
  }, {
    key: "copy",
    value: function copy() {
      if (this.lc.tool.name !== 'SelectShape' || !this.lc.tool.selectedShape) {
        return;
      }
      var shape = this.lc.tool.selectedShape;
      this.clipboard = {
        className: shape.className,
        data: shape.toJSON()
      };
      this.updateEditMenu();
    }
  }, {
    key: "cut",
    value: function cut() {
      if (this.lc.tool.name !== 'SelectShape' || !this.lc.tool.selectedShape) {
        return;
      }
      this.copy();
      var shape = this.lc.tool.selectedShape;
      this.lc.removeShape(shape);
      this.lc.tool.setShape(this.lc, null);
    }
  }, {
    key: "paste",
    value: function paste() {
      if (!this.clipboard) {
        return;
      }
      var shape = this.lc.addShape(this.clipboard);
      this.lc.setTool(this.lc.tools.SelectShape);
      this.lc.tool.setShape(this.lc, shape);
    }
  }, {
    key: "updateEditMenu",
    value: function updateEditMenu() {
      var isSelected = this.lc.tool.name === 'SelectShape' ? 'block' : 'none';
      // this._cutButton.style.display = isSelected;
      // this._copyButton.style.display = isSelected;
      // this._pasteButton.style.display = this.clipboard ? "block" : "none";
    }
  }, {
    key: "fileSave",
    value: function fileSave(taskParam) {
      if (!Entry.stage.selectedObject) {
        return;
      }
      this.lc.trigger('dispose');
      var dataURL = this.lc.getImage().toDataURL();
      this.file_ = JSON.parse(JSON.stringify(this.file));
      Entry.dispatchEvent('saveCanvasImage', {
        file: this.file_,
        image: dataURL,
        task: taskParam
      });
      this.file.isUpdate = false;
      this.file.modified = false;
    }
  }, {
    key: "newPicture",
    value: function newPicture() {
      if (!Entry.stage.selectedObject) {
        return;
      }
      var newPicture = {
        dimension: {
          height: 1,
          width: 1
        },
        //filename: "_1x1",
        fileurl: "".concat(Entry.mediaFilePath, "_1x1.png"),
        thumbUrl: "".concat(Entry.mediaFilePath, "_1x1.png"),
        name: Lang.Painter.new_picture
      };
      newPicture.id = Entry.generateHash();
      if (this.file && this.file.objectId) {
        newPicture.objectId = this.file.objectId;
      }
      Entry.playground.addPicture(newPicture, true);
    }
  }, {
    key: "_keyboardPressControl",
    value: function _keyboardPressControl(e) {
      if (!this.isShow || Entry.Utils.isInInput(e)) {
        return;
      }
      var keyCode = e.keyCode || e.which;
      var ctrlKey = e.ctrlKey;
      if (keyCode == 8 || keyCode == 46) {
        //destroy
        this.cut();
        e.preventDefault();
      } else if (ctrlKey) {
        if (keyCode == 67) {
          //copy
          this.copy();
        } else if (keyCode == 88) {
          //cut
          this.cut();
        }
      }
      if (ctrlKey && keyCode == 86) {
        //paste
        this.paste();
      }
      this.lc.trigger('keyDown', e);
    }
  }, {
    key: "_keyboardUpControl",
    value: function _keyboardUpControl(e) {
      if (!this.isShow || Entry.Utils.isInInput(e)) {
        return;
      }
      this.lc.trigger('keyUp', e);
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(isFullscreen) {
      var _Entry$playground = Entry.playground,
        _Entry$playground$pai = _Entry$playground.painter,
        painter = _Entry$playground$pai === void 0 ? {} : _Entry$playground$pai,
        pictureView_ = _Entry$playground.pictureView_;
      var _painter$view = painter.view,
        view = _painter$view === void 0 ? {} : _painter$view;
      var $view = $(view);
      if (isFullscreen !== true && $view.hasClass('fullscreen') || isFullscreen === false) {
        pictureView_.appendChild(view);
        $(view).removeClass('fullscreen');
        if (this.fullscreenButton) {
          this.fullscreenButton.setAttribute('title', Lang.Painter.fullscreen);
          this.fullscreenButton.setAttribute('alt', Lang.Painter.fullscreen);
        }
      } else {
        document.body.appendChild(view);
        $(view).addClass('fullscreen');
        if (this.fullscreenButton) {
          this.fullscreenButton.setAttribute('title', Lang.Painter.exit_fullscreen);
          this.fullscreenButton.setAttribute('alt', Lang.Painter.exit_fullscreen);
        }
      }
      $(view).find('.lc-drawing.with-gui').trigger('resize');
    }
  }, {
    key: "initTopBar",
    value: function initTopBar() {
      var _this2 = this;
      var painter = this;
      var ce = Entry.createElement;
      var painterTop = ce(document.getElementById('canvas-top-menu'));
      painterTop.addClass('entryPlaygroundPainterTop');
      painterTop.addClass('entryPainterTop');
      var painterTopFullscreenButton = ce('div', 'entryPainterTopFullscreenButton');
      painterTopFullscreenButton.setAttribute('title', Lang.Painter.fullscreen);
      painterTopFullscreenButton.setAttribute('alt', Lang.Painter.fullscreen);
      painterTopFullscreenButton.addClass('entryPlaygroundPainterFullscreenButton');
      painterTopFullscreenButton.bindOnClick(function () {
        _this2.toggleFullscreen();
      });
      this.fullscreenButton = painterTopFullscreenButton;
      painterTop.appendChild(painterTopFullscreenButton);
      var painterTopMenu = ce('nav', 'entryPainterTopMenu');
      painterTopMenu.addClass('entryPlaygroundPainterTopMenu');
      painterTop.appendChild(painterTopMenu);
      var painterTopMenuFileNew = ce('div', 'entryPainterTopMenuFileNew');
      painterTopMenuFileNew.bindOnClick(painter.newPicture.bind(this));
      painterTopMenuFileNew.addClass('entryPlaygroundPainterTopMenuFileNew');
      painterTopMenuFileNew.innerHTML = Lang.Painter.new_picture;
      painterTopMenu.appendChild(painterTopMenuFileNew);
      var painterTopMenuFile = ce('div', 'entryPainterTopMenuFile');
      painterTopMenuFile.addClass('entryPlaygroundPainterTopMenuFile painterTopHeader');
      painterTopMenuFile.innerHTML = Lang.Painter.file;
      var painterTopMenuFileDropdown = ce('div');
      painterTopMenuFileDropdown.addClass('entryPlaygroundPainterTopMenuFileDropdown');
      painterTopMenu.appendChild(painterTopMenuFile);
      painterTopMenuFile.appendChild(painterTopMenuFileDropdown);
      var painterTopMenuEdit = ce('div', 'entryPainterTopMenuEdit');
      painterTopMenuEdit.addClass('entryPlaygroundPainterTopMenuEdit painterTopHeader');
      painterTopMenuEdit.innerHTML = Lang.Painter.edit;
      painterTopMenu.appendChild(painterTopMenuEdit);
      var painterTopMenuFileSave = ce('div', 'entryPainterTopMenuFileSave');
      painterTopMenuFileSave.bindOnClick(function () {
        painter.fileSave(false);
      });
      painterTopMenuFileSave.addClass('entryPainterTopMenuFileSave');
      painterTopMenuFileSave.innerHTML = Lang.Painter.painter_file_save;
      painterTopMenuFileDropdown.appendChild(painterTopMenuFileSave);
      var painterTopMenuFileSaveAsLink = ce('div', 'entryPainterTopMenuFileSaveAs');
      painterTopMenuFileSaveAsLink.bindOnClick(function () {
        painter.file.mode = 'new';
        painter.fileSave(false);
      });
      painterTopMenuFileSaveAsLink.addClass('entryPlaygroundPainterTopMenuFileSaveAs');
      painterTopMenuFileSaveAsLink.innerHTML = Lang.Painter.painter_file_saveas;
      painterTopMenuFileDropdown.appendChild(painterTopMenuFileSaveAsLink);
      var painterTopMenuEditDropdown = ce('div');
      painterTopMenuEditDropdown.addClass('entryPlaygroundPainterTopMenuEditDropdown');
      painterTopMenuEdit.appendChild(painterTopMenuEditDropdown);
      var painterTopMenuEditImport = ce('div', 'entryPainterTopMenuEditImport');
      painterTopMenuEditImport.bindOnClick(function () {
        Entry.dispatchEvent('openPictureImport');
      });
      painterTopMenuEditImport.addClass('entryPainterTopMenuEditImport');
      painterTopMenuEditImport.innerHTML = Lang.Painter.get_file;
      painterTopMenuEditDropdown.appendChild(painterTopMenuEditImport);
      var painterTopMenuEditCopy = ce('div', 'entryPainterTopMenuEditCopy');
      painterTopMenuEditCopy.bindOnClick(function () {
        painter.copy();
      });
      painterTopMenuEditCopy.addClass('entryPlaygroundPainterTopMenuEditCopy');
      painterTopMenuEditCopy.innerHTML = Lang.Painter.copy_file;
      painterTopMenuEditDropdown.appendChild(painterTopMenuEditCopy);
      var painterTopMenuEditCut = ce('div', 'entryPainterTopMenuEditCut');
      painterTopMenuEditCut.bindOnClick(function () {
        painter.cut();
      });
      painterTopMenuEditCut.addClass('entryPlaygroundPainterTopMenuEditCut');
      painterTopMenuEditCut.innerHTML = Lang.Painter.cut_picture;
      painterTopMenuEditDropdown.appendChild(painterTopMenuEditCut);
      var painterTopMenuEditPaste = ce('div', 'entryPainterTopMenuEditPaste');
      painterTopMenuEditPaste.bindOnClick(function () {
        painter.paste();
      });
      painterTopMenuEditPaste.addClass('entryPlaygroundPainterTopMenuEditPaste');
      painterTopMenuEditPaste.innerHTML = Lang.Painter.paste_picture;
      painterTopMenuEditDropdown.appendChild(painterTopMenuEditPaste);
      var painterTopMenuEditEraseAll = ce('div', 'entryPainterTopMenuEditEraseAll');
      painterTopMenuEditEraseAll.addClass('entryPlaygroundPainterTopMenuEditEraseAll');
      painterTopMenuEditEraseAll.innerHTML = Lang.Painter.remove_all;
      painterTopMenuEditEraseAll.bindOnClick(function () {
        painter.lc.clear();
      });
      painterTopMenuEditDropdown.appendChild(painterTopMenuEditEraseAll);
      $(painterTopMenuFile).on('click tab', menuClickEvent);
      $(painterTopMenuEdit).on('click tab', menuClickEvent);
      $(document).on('click tap', function (e) {
        e.stopPropagation();
        $(painterTopMenuFile).removeClass('active');
        $(painterTopMenuEdit).removeClass('active');
      });
      var painterTopStageXY = ce('div', 'entryPainterTopStageXY');
      var entryPainterTopStageXYLabel = ce('span', 'entryPainterTopStageXYLabel');
      this.painterTopStageXY = entryPainterTopStageXYLabel;
      painterTopStageXY.addClass('entryPlaygroundPainterTopStageXY');
      entryPainterTopStageXYLabel.addClass('entryPainterTopStageXYLabel');
      painterTopStageXY.appendChild(entryPainterTopStageXYLabel);
      painterTop.appendChild(painterTopStageXY);
      Entry.addEventListener('pictureSelected', this.changePicture.bind(this));
      function menuClickEvent(e) {
        $(painterTopMenuFile).removeClass('active');
        $(painterTopMenuEdit).removeClass('active');
        if (e.target === this) {
          e.stopImmediatePropagation();
          $(this).addClass('active');
        }
      }
    }
  }, {
    key: "stagemousemove",
    value: function stagemousemove(event) {
      this.painterTopStageXY.textContent = "x:".concat(event.x.toFixed(1), ", y:").concat(event.y.toFixed(1));
    }
  }, {
    key: "attachKeyboardEvents",
    value: function attachKeyboardEvents() {
      this.detachKeyboardEvents();
      var events = this._keyboardEvents;
      var evt = Entry.keyPressed;
      evt && events.push(evt.attach(this, this._keyboardPressControl));
      evt = Entry.keyUpped;
      evt && events.push(evt.attach(this, this._keyboardUpControl));
    }
  }, {
    key: "detachKeyboardEvents",
    value: function detachKeyboardEvents() {
      var events = this._keyboardEvents;
      if (!events || !events.length) {
        return;
      }
      while (events.length) {
        var evt = events.pop();
        evt.destroy && evt.destroy();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.toggleFullscreen(false);
    }
  }, {
    key: "undo",
    value: function undo() {
      this.lc.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      if (this.lc.canRedo()) {
        this.lc.redo();
      }
    }
  }]);
}();